export class Delivery {
  public constructor() { this.contactId = []; }
  idDelivery?: number;
  contactId: number[];
  type: string;
  status: string;
  message: string;
  subject: string;
  tags: string | string[] | null;
  filters: string;
}

export function interpretServerDelivery(delivery: any): Delivery {
  const instance = Object.assign(new Delivery(), delivery);
  // Tags property as empty string means no selected tags
  if (typeof instance.tags === "string" && instance.tags.length === 0) {
    instance.tags = null;
  }
  return instance;
}
